import { render, staticRenderFns } from "./singleAgency.vue?vue&type=template&id=2e4507bc&"
import script from "./singleAgency.vue?vue&type=script&lang=js&"
export * from "./singleAgency.vue?vue&type=script&lang=js&"
import style0 from "./singleAgency.vue?vue&type=style&index=0&id=2e4507bc&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports